export const LOAD_STOPS = "LOAD_STOPS";
export const LOAD_STOP_COMPLETE = "LOAD_STOP_COMPLETE";

export const LOAD_ARRIVALS_COMPLETE = "LOAD_ARRIVALS_COMPLETE";
export const LOAD_ARRIVALS = "LOAD_ARRIVALS";

export const LOAD_ARRIVALS_DATA_REQUEST = "LOAD_ARRIVALS_DATA_REQUEST";
export const LOAD_STOP_DATA_REQUEST = "LOAD_STOP_DATA_REQUEST";

export const CHANGE_VIEW_REQUEST = "CHANGE_VIEW_REQUEST";
export const CHANGE_VIEW = "CHANGE_VIEW";
export const INITIAL_LOAD_REQUEST = "INITIAL_LOAD_REQUEST";

export const BOOKMARK_STOP_REQUEST = "BOOKMARK_STOP_REQUEST";
export const REMOVE_BOOKMARK_STOP_REQUEST = "REMOVE_BOOKMARK_STOP_REQUEST";
export const CREATE_STOP_BOOKMARK = "CREATE_STOP_BOOKMARK";
export const REMOVE_STOP_BOOKMARK = "REMOVE_STOP_BOOKMARK";
export const LOAD_BOOKMARKS_COMPLETE = "LOAD_BOOKMARKS_COMPLETE";

export const CURRENT_LOCATION_LOAD_COMPLETE = "CURRENT_LOCATION_LOAD_COMPLETE";

export const UPDATE_VIEW_REQUEST = "UPDATE_VIEW_REQUEST";

export const LOAD_ROUTE_DATA_REQUEST = "LOAD_ROUTE_DATA_REQUEST";
export const LOAD_ROUTE_COMPLETE = "LOAD_ROUTE_COMPLETE";
export const LOAD_ROUTE_DATA = "LOAD_ROUTE_DATA";

export const LOAD_ROUTE_ALERT_DATA_REQUEST = "LOAD_ROUTE_ALERT_DATA_REQUEST";
export const LOAD_ROUTES_ALERT_DATA = "LOAD_ROUTES_ALERT_DATA";
export const LOAD_ROUTE_ALERTS_COMPLETE = "LOAD_ROUTE_ALERTS_COMPLETE";
export const LOAD_ALL_ROUTES_COMPLETE = "LOAD_ALL_ROUTES_COMPLETE";
export const LOAD_ALL_ROUTES_DATA_REQUEST = "LOAD_ALL_ROUTES_DATA_REQUEST";
